import { useState } from 'react'

const ALL_IMAGES = [
  { src: '/images/optimized/IMG_5094.webp', alt: 'Cabin bedroom', category: 'interior' },
  { src: '/images/optimized/IMG_5095.webp', alt: 'Room with valley view', category: 'interior' },
  { src: '/images/optimized/IMG_5108.webp', alt: 'Cabin interior', category: 'interior' },
  { src: '/images/optimized/IMG_5109.webp', alt: 'Forest path', category: 'landscape' },
  { src: '/images/optimized/IMG_5111.webp', alt: 'Treehouse sitting area', category: 'interior' },
  { src: '/images/optimized/IMG_5113.webp', alt: 'The Canopy Loft', category: 'treehouse' },
  { src: '/images/optimized/IMG_5115.webp', alt: 'Treehouse interior', category: 'treehouse' },
  { src: '/images/optimized/IMG_5118.webp', alt: 'Valley panorama', category: 'landscape' },
  { src: '/images/optimized/IMG_5132.webp', alt: 'Cabin room', category: 'interior' },
  { src: '/images/optimized/IMG_5143.webp', alt: 'Wooden cabin', category: 'interior' },
  { src: '/images/optimized/IMG_5147.webp', alt: 'Dining area', category: 'dining' },
  { src: '/images/optimized/IMG_5150.webp', alt: 'Family cabin', category: 'interior' },
  { src: '/images/optimized/IMG_5164.webp', alt: 'The Canopy Nest', category: 'treehouse' },
  { src: '/images/optimized/IMG_5168.webp', alt: 'Treehouse view', category: 'treehouse' },
  { src: '/images/optimized/IMG_5169.webp', alt: 'Mountain forest', category: 'landscape' },
  { src: '/images/optimized/IMG_5174.webp', alt: 'Scenic Solitude entrance', category: 'landscape' },
]

const CATEGORIES = [
  { label: 'All', value: 'all' },
  { label: 'Treehouses', value: 'treehouse' },
  { label: 'Interiors', value: 'interior' },
  { label: 'Landscape', value: 'landscape' },
  { label: 'Dining', value: 'dining' },
]

export function GalleryGrid() {
  const [active, setActive] = useState('all')
  const [lightbox, setLightbox] = useState<string | null>(null)

  const filtered = active === 'all' ? ALL_IMAGES : ALL_IMAGES.filter(img => img.category === active)

  return (
    <div>
      {/* Filter tabs */}
      <div className="mb-10 flex flex-wrap gap-2">
        {CATEGORIES.map(cat => (
          <button
            key={cat.value}
            onClick={() => setActive(cat.value)}
            className={`px-5 py-1.5 text-[11px] tracking-widest2 uppercase font-medium border transition-all duration-200 ${
              active === cat.value
                ? 'bg-ink text-cream-100 border-ink'
                : 'border-ink/20 text-ink-muted hover:text-ink'
            }`}
            onMouseEnter={e => {
              if (cat.value !== active) e.currentTarget.style.boxShadow = 'inset 0 0 0 1px #2d5a3d, 0 4px 20px 0 rgba(30,53,37,0.18)'
            }}
            onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none' }}
          >
            {cat.label}
          </button>
        ))}
      </div>

      {/* Grid */}
      <div className="grid gap-1 sm:grid-cols-2 lg:grid-cols-3">
        {filtered.map((img, i) => (
          <button
            key={img.src}
            onClick={() => setLightbox(img.src)}
            className="group relative overflow-hidden bg-cream-200 focus:outline-none"
            style={{ aspectRatio: i % 5 === 0 ? '16/9' : '4/3' }}
          >
            <img
              src={img.src}
              alt={img.alt}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-ink/0 group-hover:bg-ink/20 transition-colors duration-300" />
          </button>
        ))}
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-ink/90 p-4"
          onClick={() => setLightbox(null)}
        >
          <img
            src={lightbox}
            alt="Gallery"
            className="max-h-[90vh] max-w-[90vw] object-contain shadow-2xl"
            onClick={e => e.stopPropagation()}
          />
          <button
            onClick={() => setLightbox(null)}
            className="absolute top-6 right-8 text-white/70 hover:text-white text-3xl font-light leading-none"
            aria-label="Close"
          >
            ×
          </button>
        </div>
      )}
    </div>
  )
}
